// extracted by mini-css-extract-plugin
export default {"rating":"jP-z","numberOfStars":"kP-z","count":"lP-z","barGraphSpacing":"mP-z","barGraph":"nP-z"};